(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('.odd-feature-video').forEach(hero => {
      if (hero.dataset.videoReady) return;
      const video = hero.querySelector('video');
      if (!video) return;
      hero.dataset.videoReady = 'true';
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let visible = true;
      video.muted = true;
      const sync = () => {
        if (!visible || document.hidden || reduced.matches || navigator.connection?.saveData) video.pause();
        else video.play().catch(() => {});
      };
      video.addEventListener('error', () => { video.hidden = true; });
      reduced.addEventListener('change', sync);
      document.addEventListener('visibilitychange', sync);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(entries => {
          visible = entries[0].isIntersecting;
          sync();
        }, { threshold: 0.1 }).observe(hero);
      } else sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
